import { useEffect, useEffectEvent, useRef, useState } from 'react';

import { useTranslation } from '@cms/i18n/client';
import styles from '@common/atoms/SearchBox/SearchBox.module.scss';
import { SearchIcon } from '@common/svg/icons/components/SearchIcon';

export interface Props {
    currentSearch: string;
    onSubmit: (SearchText: string) => Promise<boolean> | void;
}

const DEBOUNCE_INTERVAL = 750;

export const SearchBox = ({ currentSearch, onSubmit }: Props) => {
    const __components = useTranslation('components').t;
    const [value, setValue] = useState<string>(currentSearch);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const onDebounceFinished = useEffectEvent((searchValue: string) => {
        if (searchValue !== currentSearch) {
            void onSubmit(searchValue);
        }
    });

    useEffect(() => {
        setValue(currentSearch);
    }, [currentSearch]);

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            onDebounceFinished(value);
        }, DEBOUNCE_INTERVAL);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [value]);

    return (
        <div className={styles.SearchBox}>
            <SearchIcon />
            <input
                type="search"
                value={value}
                name="search"
                autoComplete="off"
                placeholder={__components('SearchBox.placeholder')}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        void onSubmit(value);
                    }
                }}
                onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue !== value) {
                        setValue(newValue);
                    }
                }}
            />
        </div>
    );
};
